module.exports = __webpack_public_path__ + "img/hyal-4@2x.395ce270.png";